import clsx from "clsx";

const FixedArea = ({children, ...props}: {children: React.ReactNode, className?: string}) => {

    return (
        <div {...props} className={clsx('w-full h-auto bg-white !py-4 !px-6', props.className)}>
            {children}
        </div>
    );
};

export default FixedArea;